<template>
  <div
    v-if="!isAdded"
    class="flex items-center justify-center flex-col"
  >
    <button
      data-test-id="add-to-favourites"
      class="invisible-btn"
      @click="toggleFavourites"
    >
      <TagIcon
        :icon="HeartEmptyIcon"
        color="mono-black"
        class="mr-2 h-5 w-5"
      />

      <span class="font-semibold text-grey-600">Add to Favourites</span>
    </button>
  </div>

  <div
    v-else
    class="flex items-center justify-center flex-col"
  >
    <button
      data-test-id="added-to-favourites"
      class="invisible-btn"
      @click="toggleFavourites"
    >
      <TagIcon
        :icon="HeartFullIcon"
        color="brand-secondary-dark"
        class="mr-2 h-5 w-5"
      />

      <span class="font-semibold text-grey-600">Added to Favourites</span>
    </button>

    <BaseButton
      color="inverse"
      class="py-2 mb-1"
      href="/favourites"
    >
      Go to Favourites
    </BaseButton>
  </div>
</template>

<script>
import HeartFullIcon from '@tagvenue/icons/24/bold/general/heart-rounded.svg';
import HeartEmptyIcon from '@tagvenue/icons/24/line/general/heart-rounded.svg';
import { markRaw } from 'vue';

import TagIcon from '@/components/TagIcon.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'AddToFavourites',
  components: { BaseButton, TagIcon },
  data() {
    return {
      HeartEmptyIcon: markRaw(HeartEmptyIcon),
      HeartFullIcon: markRaw(HeartFullIcon),
    };
  },

  computed: {
    isAdded() {
      return this.$store.state.wishlist.isRoomFavourite;
    },
  },

  methods: {
    toggleFavourites() {
      this.$store.dispatch('wishlist/toggleWishlist');
    },
  },
  mounted() {
    $.subscribe('wishList:change', () => {
      this.$store.dispatch('wishlist/fetchRoomInWishlist');
    });
  },
};
</script>

<style lang="scss" scoped>
@use '@sass/design-system/variables' as ds-variables;

.invisible-btn {
  align-items: center;
  display: flex;
  border: none;
  background: transparent;
  padding: 8px 20px;
  border-radius: 6px;
  transition: all 0.3s;
  transition-property: background-color, color, border-color;

  &:hover {
    background: ds-variables.$grey-100;
  }
  &:active {
    background: ds-variables.$grey-200;
  }
}
</style>
